<div>
  @if (!sessionBootstrap.shouldHideRouterOutlet()) {
    <router-outlet />
  }
  <app-global-spinner />
  <app-toast></app-toast>
</div>
